import React from "react";
import PropTypes from "prop-types";
import { withUser, meetsLevel, ACCESS_DOMAINS } from "@/helpers/user";
import { Button } from "antd";

const styles = {
  container: {
    padding: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  help: {
    flex: 1,
    textAlign: "center"
  }
};

const UserAccess = ({
  user,
  domain = "app",
  isPublicSignupAllowed = false,
  showHelp = true,
  helpText = "Please Login to Access",
  helpButtonSize = "default",
  children,
  style
}) => {
  const { action, accessLevel } = user;
  const level = accessLevel[domain];
  const isMember = meetsLevel(level, "full");
  return meetsLevel(level, "guest") ? (
    isMember || isPublicSignupAllowed ? (
      <div style={style}>{children}</div>
    ) : showHelp ? (
      <div style={styles.container}>
        <div style={styles.help}>
          <Button disabled={true} size={helpButtonSize}>
            {"Access Restricted"}
          </Button>
          <br />
          <a href="//www.unifiedpatents.com/join/" target="_blank" rel="noopener noreferrer">
            <small>{"Please upgrade your membership to gain full access."}</small>
          </a>
        </div>
      </div>
    ) : null
  ) : showHelp ? (
    <div style={styles.container}>
      <div style={styles.help}>
        <Button type="primary" size={helpButtonSize} onClick={action.showLoginPopup}>
          {helpText}
        </Button>
        <br />
        <a onClick={action.showSignupPopup}>
          <small>{"Not a member? Sign up for free!"}</small>
        </a>
      </div>
    </div>
  ) : null;
};
UserAccess.propTypes = {
  domain: PropTypes.oneOf(ACCESS_DOMAINS),
  isPublicSignupAllowed: PropTypes.bool, // usually users without any role, because they sign up by themselves
  showHelp: PropTypes.bool,
  helpText: PropTypes.string,
  helpButtonSize: PropTypes.string
};

export default withUser(UserAccess);
